// extracted by mini-css-extract-plugin
module.exports = {"content":"MerchantSupport_index_content__3Qapv"};